import React from 'react'
import './styles.scss'

const VideoOverlay = ({ toggleVideoModal }) => (
  <div className="video-overlay" onClick={toggleVideoModal}>
    <div className="video-overlay-button">
      <div className="video-overlay-button-inner">
        <div className="video-overlay-button-inner-2">
          <div className="video-overlay-play-button" />
        </div>
      </div>
    </div>
  </div>
)

export default VideoOverlay
